export default __webpack_public_path__ + "static/media/p14.07026eed.jpeg";